module.exports = __webpack_public_path__ + "img/dundrum2_big.4421d3bf.png";